__turbopack_context__.v({
  "collectionsDropdown": "CollectionsDropdown-module-scss-module__qXyjLa__collectionsDropdown",
});
